import React from 'react';
import { useNavigate } from 'react-router-dom';
import img from '../images/onboarding-dashboard2.png';
import img2 from '../images/slider2.png';

export default function Splash2() {
  const navigate = useNavigate();

  const handleSkip = () => {
    navigate('/login');
  };

  const handleNext = () => {
    navigate('/splash3');
  };

  return (
    <div className='splashnew-container1'>
      <div className='onboarding-dashboard-img'>
        <img src={img} alt="" />
      </div>
      <div className='onboarding-bg'>
        <div className='onboarding-content'>
          <h3>Take a feature tour and connect to your patients</h3>
          <div className='onboarding-img'>
            <img src={img2} alt="" />
          </div>
          <div className='onboarding-btn'>
            <div className='onboarding-btn1'>
              <button onClick={handleSkip}>Skip</button>
            </div>
            <div className='onboarding-btn2'>
              <button onClick={handleNext}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
